import { render, staticRenderFns } from "./SessionDialog.vue?vue&type=template&id=387a3cd6"
import script from "./SessionDialog.vue?vue&type=script&lang=js"
export * from "./SessionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports